// extracted by mini-css-extract-plugin
export default {"chipContent":"style_chipContent__+Zgn7","headerWrapper":"style_headerWrapper__KsXrx","headerContent":"style_headerContent__TzN5G","contentWrapper":"style_contentWrapper__MyY1l"};